import { Component, Input, OnInit } from "@angular/core";

export interface CardItem {
  icon: string;
  alt: string;
  text: string;
  value: number;
}

@Component({
  selector: "app-cards-metricas",
  templateUrl: "./cards-metricas.component.html",
  styleUrls: ["./cards-metricas.component.scss"],
})
export class CardsMetricasComponent {
  @Input() cards: CardItem[] = [];
  @Input() justifyCenter: boolean = false;
  @Input() columns: string = "col-6 col-md-2";
}
